// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


import Vue from "vue";
import money from 'v-money';
import App from "./App";
import router from "./router";
import { store } from "./store"; // importamos el modulo de store
// import VModal from 'vue-js-modal'

import { ApiService, TokenService } from "./services";
import { global } from './mixins/global'

import _ from 'lodash';

import 'jquery/src/jquery.js'
import "izitoast/dist/css/iziToast.css";

import "./services/createResponseInterceptor"

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm, info) => { 
  console.log(err)
  // err: error trace
  // vm: component in which error occured
  // info: Vue specific error information such as lifecycle hooks, events etc.

  // TODO: Perform any custom logic or log to server
};

// Set the base URL of the API
ApiService.init(process.env.API_URI);

// If token exists set header
// if (TokenService.getToken()) {
//   ApiService.setHeader();
// }

Vue.use(require('vue-moment'));
// Vue.use(VueTheMask)
// Vue.use(VModal,{ dynamic: true, injectModalsContainer: true })
Vue.use(money, { precision: 2 } )
Vue.mixin(global);

NProgress.configure({ easing: 'ease', speed: 500 });

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js